import { render, staticRenderFns } from "./JobEditor.vue?vue&type=template&id=453542d6"
import script from "./JobEditor.vue?vue&type=script&lang=js"
export * from "./JobEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports